import React, { useEffect, useState } from 'react';
import Grade from '../../atoms/Icons/Grade';
import DropUpArrow from '../../atoms/Icons/DropUpArrow';
import DropDownArrow from '../../atoms/Icons/DropDownArrow';
import BodySmall from '../../atoms/Text/BodySmall';
import BodyMediumSemibold from '../../atoms/Text/BodyMediumSemibold';
import Button from '../../atoms/Button';

const ReviewSection = ({ reviews = [], title = '' }) => {
  const [showAllReviews, setShowAllReviews] = useState(true);

  useEffect(() => {
    setShowAllReviews(false);
  }, []);

  const averageRating = React.useMemo(() => {
    if (!reviews || reviews.length === 0) {
      return '0';
    }

    const totalRating = reviews.reduce((sum, review) => sum + review.rating, 0);
    return (totalRating / reviews.length).toFixed(1);
  }, [reviews]);

  const reviewsToDisplay = showAllReviews ? reviews : reviews.slice(0, 3);

  reviews = reviews.sort((a, b) => {
    const dateA = new Date(
      a.createdDate.split(' ')[0].split('-').reverse().join('-') + 'T' + a.createdDate.split(' ')[1]
    );
    const dateB = new Date(
      b.createdDate.split(' ')[0].split('-').reverse().join('-') + 'T' + b.createdDate.split(' ')[1]
    );
    return dateB.getTime() - dateA.getTime();
  });

  return (
    <section
      className="text-reliableBlack bg-reliableBlack5 mx-4 lg:mx-0 px-5 lg:px-0 py-3 lg:py-16"
      data-testid="review-section"
    >
      <div className="md:container md:px-0">
        <div className="flex justify-between mb-5">
          <div>
            <h2 className="font-bold mb-[6px] lg:text-2xl uppercase">{title}</h2>
            <div className="flex items-center">
              <Grade />
              <BodySmall className="lg:text-lg">
                {`${averageRating}/5 (Dari ${reviews.length} Ulasan)`}
              </BodySmall>
            </div>
          </div>
        </div>
        <div
          className={`review-container  ${
            showAllReviews
              ? 'visible max-h-[500px] opacity-100 overflow-y-scroll'
              : 'opacity-100 max-h-[300px] overflow-hidden'
          }`}
        >
          <ul className="px-2">
            {reviewsToDisplay.map((review, idx) => (
              <li
                key={review.id}
                className="flex justify-between gap-3 pb-[10px] mb-[10px] border-b border-reliableBlack70 last:border-none lg:border-[#E7E7E7] lg:pb-5 lg:mb-5"
              >
                <div>
                  <BodyMediumSemibold className={`reviewer-${idx + 1} mb-1 lg:text-xl lg:mb-2`}>
                    {review.reviewerName}
                  </BodyMediumSemibold>
                  {review.message && (
                    <BodySmall className={`review-${idx + 1} lg:text-base`}>
                      {`"${review.message}"`}
                    </BodySmall>
                  )}
                </div>
                <div className={`flex items-center`}>
                  <span>
                    <Grade />
                  </span>
                  <BodySmall className={`rating-${idx + 1} lg:text-2xl`}>{review.rating}</BodySmall>
                </div>
              </li>
            ))}
          </ul>
        </div>
        {reviews.length > 3 && (
          <div className="flex justify-center lg:justify-start">
            <Button
              onClick={() => setShowAllReviews(!showAllReviews)}
              variant="bg-[#f8f8f8]"
              className="block m-auto lg:m-0 lg:p-0"
            >
              <div className="flex">
                <span className="text-xs font-medium uppercase leading-relaxed text-hyperLink lg:text-base">
                  {showAllReviews ? 'Lihat Lebih Sedikit' : 'Lihat Selengkapnya'}
                </span>
              </div>
            </Button>
          </div>
        )}
      </div>
    </section>
  );
};

export default ReviewSection;
